import { push } from 'connected-react-router';
import { loadableDataActions } from '../../../common/utils/LoadableData';
import { BackOfficeCompanyDTO } from '../../../services/types/BoApiTypes';
import { DispatchThunk } from '../../../storeConfig';
import api from '../../../services/ApiServices';
import { notify } from '../../../common/utils/notify';
import i18n from '../../../i18n';

const ns = 'back-office/company/details/';

export const boCompanyDetailsLoadableActions = loadableDataActions<string, BackOfficeCompanyDTO>(`${ns}BO_COMPANY_DETAILS_LOADABLE`);
export const boCompanyGrantAccessLoadableActions = loadableDataActions<string, null>(`${ns}BO_COMPANY_GRANT_ACCESS`);
export const boCompanyCloneDatabaseLoadableActions = loadableDataActions<string, BackOfficeCompanyDTO>(`${ns}BO_COMPANY_CLONE`);

export const getBoCompany = (companyGuid: string) => {
    return async (dispatch: DispatchThunk) => {
        try {
            dispatch(boCompanyDetailsLoadableActions.request(companyGuid));
            const response = await api.boCompanies.getCompanyByGuid(companyGuid);
            dispatch(boCompanyDetailsLoadableActions.success(response.data));
        } catch (e) {
            console.error(e);
        }
    };
};

export const grantAccess = (companyGuid: string) => {
    return async (dispatch: DispatchThunk) => {
        try {
            dispatch(boCompanyGrantAccessLoadableActions.request(companyGuid));
            await api.boCompanies.grantAccess(companyGuid);
            dispatch(boCompanyGrantAccessLoadableActions.success(null));
            notify.success(i18n.t('view.backOffice.companies.actions.grantAccess.grantedSuccessfully'));
        } catch (e) {
            console.error(e);
            dispatch(boCompanyGrantAccessLoadableActions.error(e));
            notify.error(i18n.t('view.backOffice.companies.actions.grantAccess.grantAccessError'));
        }
    };
};

export const cloneDatabase = (companyGuid: string) => {
    return async (dispatch: DispatchThunk) => {
        try {
            dispatch(boCompanyCloneDatabaseLoadableActions.request(companyGuid));
            notify.info(i18n.t('view.backOffice.companies.actions.clone.isCloning'), i18n.t('view.backOffice.companies.actions.clone.isCloningTitle'), {
                toastOptions: { autoClose: 4000 },
            });
            const response = await api.boCompanies.cloneDatabase(companyGuid);
            dispatch(boCompanyCloneDatabaseLoadableActions.success(null));
            dispatch(push(`/backoffice/companies/${response?.data?.CompanyGuid}`));
            notify.success(i18n.t('view.backOffice.companies.actions.clone.clonedSuccessfully'));
        } catch (e) {
            console.error(e);
            dispatch(boCompanyCloneDatabaseLoadableActions.error(e));
            dispatch(push(`/backoffice/companies/${companyGuid}`));
            notify.error(i18n.t('view.backOffice.companies.actions.clone.cloneError'));
        }
    };
};
